export default "__VITE_ASSET__08b9bcd8__"